const ReducedMotionStore = {
  /**
   * Whether motion is reduced
   */
  reduceMotion: false,

  toggle() {
    this.reduceMotion = !this.reduceMotion;
  }
};

export default ReducedMotionStore;
